export function calculateLoanAmount(spa, loan_margin) {
    let loan_amount = spa * (loan_margin/100)
    return parseFloat2Decimal(loan_amount)
}

export function calculateInstallment(loan_amt, interest_rate, tenure_year) {
    if(interest_rate == 0 || interest_rate == ''){
        let m = loan_amt / (tenure_year * 12)
        return parseFloat2Decimal(m)
    }else{
        let p = parseFloat(loan_amt);
        let r = (parseFloat(interest_rate) !== 0) ? (parseFloat(interest_rate) / 100 / 12) : 0;
        let n = parseFloat(tenure_year) * 12;
        let m = 0;
        if ((Math.pow(1 + r, n) - 1) > 0) {
            m = p * (r * Math.pow(1 + r, n)) / (Math.pow(1 + r, n) - 1);
        }
        return parseFloat2Decimal(m)
    }
}

export function calculatePersonalLoanInstallment(loan_amt, interest_rate, tenure_year) {
    if(interest_rate == 0 || interest_rate == ''){
        let m = loan_amt / (tenure_year * 12)
        return parseFloat2Decimal(m)
    }else{
        let p = parseFloat(loan_amt);
        let r = (parseFloat(interest_rate) !== 0) ? (parseFloat(interest_rate) / 100) : 0;
        let n = parseFloat(tenure_year) * 12;
        let l = (p * r * parseFloat(tenure_year)) + p
        let m = l / n
        return parseFloat2Decimal(m)
    }
}

export function calculateClientNett(spa_price, cb_percent_to_customer){
    let client_nett = spa_price * ((100 - cb_percent_to_customer) / 100);	
    return parseFloat2Decimal(client_nett)
}

export function calculateBuyerDiscount(client_nett, spa_price){
    let buyer_discount = 100 - ((client_nett / spa_price) *100);
    return parseFloat2Decimal(buyer_discount)
}

export function calculateCashback(loan_amount, client_nett){
    let cashback = loan_amount - client_nett
    return parseFloat2Decimal(cashback)
}

export function calculateLoanMargin(spa_price, loan_amount){
    let margin = spa_price/loan_amount* 100
    return parseFloat2Decimal(margin)
}

function parseFloat2Decimal(amount){
    return parseFloat(amount).toFixed(2);
}

export function calculateInvinitySettlement(request){
	// Extract input values from request object (assuming it's similar to PHP's $request)
	const debt_amount = request.debt_amount > 0 ? request.debt_amount :1000;
	const disbursment = request.disbursment > 0 ? request.disbursment :1000;
	const tenure_year = request.tenure_year > 0 ? request.tenure_year : 1;
	const base_interest_rate = request.interest_rate > 0 ? request.interest_rate : 1.40;
	const adv_insurance = request.adv_insurance > 0 ? request.adv_insurance : 0;
	const vf_service_rate = request.vf_service_rate > 0 ? request.vf_service_rate : 0;
	const monthly_value = parseInt(tenure_year) * 12;
	const interval = 1000;

	// Initialize variables
	let interest_rate = base_interest_rate / 100;
	let loopqty = 1;
	let loop = true;
	let loan_amount = 0;
	let installment, stamp_duty, vf_service_fees, legal_fee, disbursement_to_client, debt_console_amount, stakeholder_sum, deduction;
	let first_check= null;
	let final_result;
	let stakeholder = (tenure_year <= 2) ? 1 : ((tenure_year <= 4) ? 2 : ((tenure_year <= 6) ? 3 : 4))


	console.log(request)
	while (loop) {

			vf_service_fees = (loan_amount * vf_service_rate) * 1.08;
			stamp_duty = loan_amount * 0.005;
			legal_fee = 1500 * 1.08;
			installment = ((loan_amount * interest_rate * tenure_year) + loan_amount) / monthly_value;
			stakeholder_sum = (adv_insurance > 0) ? parseFloat(adv_insurance) : (installment * stakeholder);
			debt_console_amount = loan_amount - (vf_service_fees + stamp_duty + legal_fee + stakeholder_sum + disbursment);
			disbursement_to_client = loan_amount - (vf_service_fees + stamp_duty + legal_fee + stakeholder_sum + debt_amount);
			if(debt_console_amount > debt_amount){
				if(first_check == 'SMALLER'){
					loop=false;
					break;
				}
				first_check = 'BIGGER';
			}else{
				if(first_check == 'BIGGER'){
					loop=false;
					break;
				}
				first_check = 'SMALLER';
			}

			final_result = {
				debt_amount: debt_amount,
				tenure: tenure_year,
				loan_amount: loan_amount.toFixed(2),
				installment: installment.toFixed(2),
				stamp_duty: stamp_duty.toFixed(2),
				legal_fees: legal_fee.toFixed(2),
				stakeholder_sum: stakeholder_sum.toFixed(2),
				vf_service_fees: vf_service_fees.toFixed(2),
				debt_console_amount: debt_console_amount.toFixed(2),
				disbursement_to_client: disbursement_to_client.toFixed(2),
				err_message: null
			};
			loan_amount = (first_check == 'SMALLER') ? (loan_amount + interval) : (loan_amount - interval);


			loopqty++;
			if(loopqty > 10000){
				final_result = {
					debt_amount: debt_amount,
					tenure: tenure_year,
					loan_amount: 0,
					installment: 0,
					stamp_duty: 0,
					legal_fees: 0,
					stakeholder_sum: 0,
					vf_service_fees: 0,
					debt_console_amount: 0,
					disbursement_to_client: 0,
					err_message: 'INVINITY LOOP'
				}
				break;
			}
	}
	// Return result similar to PHP's [200, $return]
	return final_result;
}